import { Select } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import CreateProfileCardWrapper from "../../components/common/CreateProfileCardWrapper";
import "./OnboardingPage.css";

const { Option } = Select;

const Duration = ({ formik }) => {
  const { t } = useTranslation();
  return (
    <CreateProfileCardWrapper>
      <h5>{t("aboutYou.ques4.title")}</h5>
      <Select
        className={`range-dropdown custom-common-select-box ${
          formik.touched.yearsLivingInCanada &&
          formik.errors.yearsLivingInCanada
            ? "error-fill"
            : formik.values.yearsLivingInCanada
            ? "data-fill"
            : ""
        }`}
        placeholder={t("aboutYou.ques4.placeholder")}
        onChange={(e) => {
          formik.setFieldValue("yearsLivingInCanada", e);
          formik.handleChange(e);
        }}
        onBlur={formik.handleBlur}
        value={formik.values.yearsLivingInCanada}
        allowClear={false}
        name="yearsLivingInCanada"
      >
        <Option value="0-6">{t("aboutYou.ques4.options.1")}</Option>
        <Option value="6-1">{t("aboutYou.ques4.options.2")}</Option>
        <Option value="1-3">{t("aboutYou.ques4.options.3")}</Option>
        <Option value="3+">{t("aboutYou.ques4.options.4")}</Option>
        <Option value="10+">{t("aboutYou.ques4.options.5")}</Option>
        <Option value="born">{t("aboutYou.ques4.options.6")}</Option>
      </Select>
      {formik.touched.yearsLivingInCanada &&
      formik.errors.yearsLivingInCanada ? (
        <div className="error-message">{formik.errors.yearsLivingInCanada}</div>
      ) : null}
    </CreateProfileCardWrapper>
  );
};

export default Duration;
